import type { LinkWrapperProps } from "@bandwith/ui";
import { Link } from "@tanstack/react-router";

/** TanStack Router link wrapper for MediaItemContent */
export function RouterLinkWrapper({
  href,
  children,
  className,
}: LinkWrapperProps) {
  return (
    <Link to={href} className={className}>
      {children}
    </Link>
  );
}
